"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ptraceInt = exports.ptraceVal = void 0;
var types_1 = require("../../type_system/types.js");
var builtins_1 = require("../builtins/index.js");
var phoist_1 = require("../phoist.js");
var plam_1 = require("../plam.js");
var pshow_1 = require("./pshow.js");
function ptraceVal(t) {
    return (0, phoist_1.phoist)((0, plam_1.plam)(t, t)(function (val) { return (0, builtins_1.ptrace)(t).$((0, pshow_1.pshow)(t).$(val).utf8Decoded).$(val); }));
}
exports.ptraceVal = ptraceVal;
;
exports.ptraceInt = ptraceVal(types_1.int);
